<nz-modal
  [(nzVisible)]="vm.createModalVisible"
  [nzWidth]="'1200px'"
  [nzStyle]="{ top: '8px' }"
  [nzMaskClosable]="false"
  [nzClosable]="false"
  [nzFooter]="null"
  nzClassName="assistant-create-modal"
  (nzOnCancel)="vm.closeCreateWizard()"
  testId="assistant-create-modal"
>
  <ng-container *nzModalContent>
    <nz-spin class="create-modal-processing-spin" [nzSpinning]="vm.submitLoading()">
      <div class="create-modal-shell" testId="assistant-create-modal-shell">
        <div class="wizard-header" testId="assistant-create-wizard-header">
          <div class="modal-title" testId="assistant-create-modal-title">
            <i nz-icon nzType="star"></i>
            {{ vm.getCreateModalTitleKey() | i18n }}
          </div>
          <button class="header-close" (click)="vm.closeCreateWizard()" testId="assistant-create-close-button"
            ><i nz-icon nzType="close"></i
          ></button>
        </div>

        <div class="step-cards">
          <ng-container *ngFor="let step of vm.visibleCreateSteps; let i = index">
            <div class="step-card" [ngClass]="['state-' + vm.getStepState(i), 'step-' + i]">
              <div class="step-icon-wrap">
                <i nz-icon [nzType]="vm.getStepState(i) === 'done' ? 'check-circle' : step.icon"></i>
              </div>
              <div class="step-title">{{ step.titleKey | i18n }}</div>
            </div>
            <div class="step-link" *ngIf="i < vm.visibleCreateSteps.length - 1"></div>
          </ng-container>
        </div>

        <div class="wizard-content">
          <ng-container [ngSwitch]="vm.createStep">
            <ng-container *ngSwitchCase="0">
              <div class="wizard-tip wizard-tip-info">
                <div class="wizard-tip-title">{{ 'assistant.management.create.basic.tip.title' | i18n }}</div>
                <div class="wizard-tip-desc">{{ 'assistant.management.create.basic.tip.desc' | i18n }}</div>
              </div>

              <div class="wizard-form-row">
                <label class="wizard-label">{{ 'assistant.management.create.basic.avatar' | i18n }} <span class="required">*</span></label>
                <div class="avatar-upload-row">
                  <div class="avatar-preview">
                    <img
                      *ngIf="vm.avatarPreview; else emptyAvatar"
                      [src]="vm.avatarPreview"
                      [alt]="'assistant.management.create.basic.avatar.alt' | i18n"
                    />
                    <ng-template #emptyAvatar>
                      <div class="avatar-empty">{{ 'assistant.management.create.basic.avatar.empty' | i18n }}</div>
                    </ng-template>
                  </div>
                  <div class="avatar-actions">
                    <label class="upload-btn" for="assistant-avatar-input">
                      <i nz-icon nzType="upload"></i>
                      {{
                        (vm.avatarPreview
                          ? 'assistant.management.create.basic.avatar.replace'
                          : 'assistant.management.create.basic.avatar.upload'
                        ) | i18n
                      }}
                    </label>
                    <input
                      id="assistant-avatar-input"
                      type="file"
                      accept="image/*"
                      (change)="vm.onAvatarFileChange($event)"
                      testId="assistant-create-avatar-input"
                    />
                    <ul>
                      <li>{{ 'assistant.management.create.basic.avatar.support' | i18n }}</li>
                      <li>{{ 'assistant.management.create.basic.avatar.suggest-size' | i18n }}</li>
                      <li>{{ 'assistant.management.create.basic.avatar.max-size' | i18n }}</li>
                    </ul>
                  </div>
                </div>
                <div class="error" *ngIf="vm.createForm.controls.avatar.dirty && vm.createForm.controls.avatar.invalid">
                  {{ 'assistant.management.create.basic.avatar.required' | i18n }}
                </div>
              </div>

              <div class="wizard-form-row">
                <label class="wizard-label">{{ 'assistant.management.create.basic.name' | i18n }} <span class="required">*</span></label>
                <input
                  nz-input
                  maxlength="50"
                  [formControl]="vm.createForm.controls.name"
                  [placeholder]="'assistant.management.create.basic.name.placeholder' | i18n"
                  testId="assistant-create-name-input"
                />
                <div class="hint"
                  >{{ (vm.createForm.controls.name.value || '').length }} / 50 {{ 'assistant.management.create.basic.chars' | i18n }}</div
                >
              </div>

              <div class="wizard-form-row">
                <label class="wizard-label"
                  >{{ 'assistant.management.create.basic.description' | i18n }} <span class="required">*</span></label
                >
                <textarea
                  nz-input
                  rows="6"
                  maxlength="200"
                  [formControl]="vm.createForm.controls.description"
                  [placeholder]="'assistant.management.create.basic.description.placeholder' | i18n"
                  testId="assistant-create-description-textarea"
                ></textarea>
                <div class="hint"
                  >{{ (vm.createForm.controls.description.value || '').length }} / 200
                  {{ 'assistant.management.create.basic.chars' | i18n }}</div
                >
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="1">
              <div class="wizard-tip wizard-tip-info">
                <div class="wizard-tip-title">{{ 'assistant.management.create.response.tip.title' | i18n }}</div>
                <div class="wizard-tip-desc">{{ 'assistant.management.create.response.tip.desc' | i18n }}</div>
              </div>

              <div class="wizard-form-row">
                <label class="wizard-label">Webhook URL <span class="required">*</span></label>
                <input
                  nz-input
                  [formControl]="vm.createForm.controls.webhookUrl"
                  [placeholder]="'assistant.management.create.response.webhook.placeholder' | i18n"
                  testId="assistant-create-webhook-input"
                />
                <div class="hint">{{ 'assistant.management.create.response.webhook.hint' | i18n }}</div>
                <div
                  class="error"
                  *ngIf="
                    (vm.createForm.controls.webhookUrl.dirty || vm.createForm.controls.webhookUrl.touched) &&
                    vm.createForm.controls.webhookUrl.hasError('required')
                  "
                >
                  {{ 'assistant.management.create.response.webhook.required' | i18n }}
                </div>
                <div
                  class="error"
                  *ngIf="
                    (vm.createForm.controls.webhookUrl.dirty || vm.createForm.controls.webhookUrl.touched) &&
                    !vm.createForm.controls.webhookUrl.hasError('required') &&
                    vm.createForm.controls.webhookUrl.hasError('pattern')
                  "
                >
                  {{ 'assistant.management.create.response.webhook.pattern' | i18n }}
                </div>
              </div>

              <div class="wizard-form-row">
                <label class="wizard-label">{{ 'assistant.management.create.response.mode' | i18n }}</label>
                <div class="mode-list">
                  <div
                    class="mode-card"
                    *ngFor="let mode of vm.responseModeCards"
                    [class.active]="vm.isResponseMode(mode.value)"
                    (click)="vm.setResponseMode(mode.value)"
                  >
                    <div class="mode-radio"><span *ngIf="vm.isResponseMode(mode.value)"></span></div>
                    <div class="mode-main">
                      <div class="mode-title">
                        <i nz-icon [nzType]="mode.icon"></i>
                        {{ mode.titleKey | i18n }}
                      </div>
                      <div class="mode-desc">{{ mode.descKey | i18n }}</div>
                      <div class="mode-usage">{{ mode.usageKey | i18n }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="batch-config-card" *ngIf="vm.isBatchMode()">
                <div class="batch-config-title">{{ 'assistant.management.create.response.batch.title' | i18n }}</div>
                <div class="batch-config-subtitle">{{ 'assistant.management.create.response.batch.subtitle' | i18n }}</div>

                <div class="batch-grid">
                  <div class="batch-field">
                    <label class="batch-label">{{ 'assistant.management.create.response.batch.count' | i18n }}</label>
                    <input
                      nz-input
                      type="number"
                      min="1"
                      [formControl]="vm.createForm.controls.batchMessageCount"
                      testId="assistant-management-batch-message-count-input"
                    />
                    <div class="batch-hint">{{ 'assistant.management.create.response.batch.count.hint' | i18n }}</div>
                    <div
                      class="error"
                      *ngIf="
                        (vm.createForm.controls.batchMessageCount.dirty || vm.createForm.controls.batchMessageCount.touched) &&
                        vm.createForm.controls.batchMessageCount.invalid
                      "
                    >
                      {{ 'assistant.management.create.response.batch.count.error' | i18n }}
                    </div>
                  </div>

                  <div class="batch-field">
                    <label class="batch-label">{{ 'assistant.management.create.response.batch.interval' | i18n }}</label>
                    <input
                      nz-input
                      type="number"
                      min="1"
                      [formControl]="vm.createForm.controls.batchIntervalMinutes"
                      testId="assistant-management-batch-interval-minutes-input"
                    />
                    <div class="batch-hint">{{ 'assistant.management.create.response.batch.interval.hint' | i18n }}</div>
                    <div
                      class="error"
                      *ngIf="
                        (vm.createForm.controls.batchIntervalMinutes.dirty || vm.createForm.controls.batchIntervalMinutes.touched) &&
                        vm.createForm.controls.batchIntervalMinutes.invalid
                      "
                    >
                      {{ 'assistant.management.create.response.batch.interval.error' | i18n }}
                    </div>
                  </div>
                </div>

                <div class="batch-field">
                  <label class="batch-label">{{ 'assistant.management.create.response.batch.keyword' | i18n }}</label>
                  <input
                    nz-input
                    [formControl]="vm.createForm.controls.batchKeywords"
                    [placeholder]="'assistant.management.create.response.batch.keyword.placeholder' | i18n"
                    testId="assistant-management-batch-keywords-input"
                  />
                  <div class="batch-hint">{{ 'assistant.management.create.response.batch.keyword.hint' | i18n }}</div>
                </div>
                <div class="error" *ngIf="vm.batchTriggerConditionMissing">
                  {{ 'assistant.management.create.response.batch.any-required' | i18n }}
                </div>
              </div>

              <div class="webhook-note">
                <div class="note-title">
                  <i nz-icon nzType="notification"></i>
                  {{ 'assistant.management.create.response.note.title' | i18n }}
                </div>
                <ul>
                  <li>{{ 'assistant.management.create.response.note.1' | i18n }}</li>
                  <li>{{ 'assistant.management.create.response.note.2' | i18n }}</li>
                  <li>{{ 'assistant.management.create.response.note.3' | i18n }}</li>
                  <li>{{ 'assistant.management.create.response.note.4' | i18n }}</li>
                </ul>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="2">
              <div class="wizard-tip wizard-tip-info">
                <div class="wizard-tip-title">{{ 'assistant.management.create.filter.tip.title' | i18n }}</div>
                <div class="wizard-tip-desc">{{ 'assistant.management.create.filter.tip.desc' | i18n }}</div>
              </div>

              <section class="filter-section">
                <div class="filter-section-head">
                  <div class="filter-section-title">
                    <span class="filter-section-icon receive">
                      <i nz-icon nzType="filter"></i>
                    </span>
                    <div class="filter-section-copy">
                      <label class="wizard-label">{{ 'assistant.management.create.filter.receive-section.title' | i18n }}</label>
                      <div class="helper-text">{{ 'assistant.management.create.filter.receive-section.desc' | i18n }}</div>
                    </div>
                  </div>
                  <div class="filter-section-rule"></div>
                </div>

                <div class="filter-section-body">
                  <div class="wizard-form-row">
                    <label class="wizard-label"
                      >{{ 'assistant.management.create.filter.message-types' | i18n }} <span class="required">*</span></label
                    >
                    <div class="helper-text">{{ 'assistant.management.create.filter.message-types.hint' | i18n }}</div>
                    <div class="option-grid two-col">
                      <div
                        class="option-card"
                        *ngFor="let option of vm.messageTypeOptions"
                        [class.selected]="vm.isOptionSelected('messageTypes', option.value)"
                        (click)="vm.toggleOption('messageTypes', option.value)"
                      >
                        <span class="check-box"
                          ><i nz-icon nzType="check" *ngIf="vm.isOptionSelected('messageTypes', option.value)"></i
                        ></span>
                        <i nz-icon [nzType]="option.icon"></i>
                        <span>{{ option.labelKey | i18n }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="wizard-form-row">
                    <label class="wizard-label"
                      >{{ 'assistant.management.create.filter.sender-types' | i18n }} <span class="required">*</span></label
                    >
                    <div class="helper-text">{{ 'assistant.management.create.filter.sender-types.hint' | i18n }}</div>
                    <div class="option-grid three-col">
                      <div
                        class="option-card"
                        *ngFor="let option of vm.senderTypeOptions"
                        [class.selected]="vm.isOptionSelected('senderTypes', option.value)"
                        (click)="vm.toggleOption('senderTypes', option.value)"
                      >
                        <span class="check-box"
                          ><i nz-icon nzType="check" *ngIf="vm.isOptionSelected('senderTypes', option.value)"></i
                        ></span>
                        <span>{{ option.labelKey | i18n }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="filter-section">
                <div class="filter-section-head">
                  <div class="filter-section-title">
                    <span class="filter-section-icon reply">
                      <i nz-icon nzType="eye"></i>
                    </span>
                    <div class="filter-section-copy">
                      <label class="wizard-label">{{ 'assistant.management.create.filter.reply-section.title' | i18n }}</label>
                      <div class="helper-text">{{ 'assistant.management.create.filter.reply-section.desc' | i18n }}</div>
                    </div>
                  </div>
                  <div class="filter-section-rule"></div>
                </div>

                <div class="filter-section-body">
                  <div class="wizard-form-row">
                    <label class="wizard-label">{{ 'assistant.management.create.filter.reply-visibility' | i18n }}</label>
                    <div class="helper-text">{{ 'assistant.management.create.filter.reply-visibility.hint' | i18n }}</div>
                    <div class="option-grid two-col">
                      <div class="option-card option-card-disabled selected" aria-disabled="true">
                        <span class="check-box"><i nz-icon nzType="check"></i></span>
                        <span>{{ 'assistant.management.create.sender-type.employee' | i18n }}</span>
                      </div>
                      <div
                        class="option-card"
                        [class.selected]="vm.isOptionSelected('replyReceiverTypes', 'Customer')"
                        (click)="vm.toggleOption('replyReceiverTypes', 'Customer')"
                      >
                        <span class="check-box"
                          ><i nz-icon nzType="check" *ngIf="vm.isOptionSelected('replyReceiverTypes', 'Customer')"></i
                        ></span>
                        <span>{{ 'assistant.management.create.sender-type.customer' | i18n }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!--
            <div class="wizard-form-row">
              <label class="wizard-label">{{ 'assistant.management.create.filter.history-days' | i18n }}</label>
              <div class="helper-text">{{ 'assistant.management.create.filter.history-days.hint' | i18n }}</div>
              <div class="history-box">
                <div class="history-head">
                  <div class="history-value">{{ vm.historyDays }} {{ 'assistant.management.create.filter.day-unit' | i18n }}</div>
                  <div class="history-range">{{ 'assistant.management.create.filter.history-range' | i18n }}</div>
                </div>
                <input
                  class="history-slider"
                  type="range"
                  min="1"
                  max="30"
                  [(ngModel)]="vm.historyDays"
                  [style.background]="vm.getHistoryRangeBackground()"
                  testId="assistant-wizard-history-days-slider"
                />
                <div class="history-scale">
                  <span>1 {{ 'assistant.management.create.filter.day-unit' | i18n }}</span>
                  <span>7 {{ 'assistant.management.create.filter.day-unit' | i18n }}</span>
                  <span>14 {{ 'assistant.management.create.filter.day-unit' | i18n }}</span>
                  <span>30 {{ 'assistant.management.create.filter.day-unit' | i18n }}</span>
                </div>
              </div>
            </div>
            -->

              <div class="wizard-form-row">
                <label class="wizard-label">{{ 'assistant.management.create.filter.summary' | i18n }}</label>
                <div class="summary-card">
                  <div
                    ><span>{{ 'assistant.management.create.filter.summary.message-types' | i18n }}</span
                    >{{ vm.getSelectedLabels('messageTypes') || '-' }}</div
                  >
                  <div
                    ><span>{{ 'assistant.management.create.filter.summary.sender-types' | i18n }}</span
                    >{{ vm.getSelectedLabels('senderTypes') || '-' }}</div
                  >
                  <div
                    ><span>{{ 'assistant.management.create.filter.summary.reply-visibility' | i18n }}</span
                    >{{ vm.getSelectedLabels('replyReceiverTypes') || '-' }}</div
                  >
                  <!--
                <div
                  ><span>{{ 'assistant.management.create.filter.summary.history' | i18n }}</span
                  >{{ vm.historyDays }} {{ 'assistant.management.create.filter.day-unit' | i18n }}</div
                >
                -->
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="3">
              <div class="payment-layout">
                <div class="payment-left">
                  <div class="wizard-form-row">
                    <label class="wizard-label">{{ 'assistant.management.create.pay.plan' | i18n }}</label>
                    <div class="helper-text">{{ 'assistant.management.create.pay.plan.hint' | i18n }}</div>
                    <div class="plan-list">
                      <div class="helper-text" *ngIf="vm.packagesLoading">{{ 'assistant.management.create.pay.plan.loading' | i18n }}</div>
                      <div
                        class="plan-item"
                        *ngFor="let plan of vm.getDisplayPricingPlans()"
                        [class.selected]="vm.selectedPricingItemId === plan.id"
                        (click)="vm.onPlanClick(plan)"
                      >
                        <div class="plan-radio"><span *ngIf="vm.selectedPricingItemId === plan.id"></span></div>
                        <div class="plan-main">
                          <div class="plan-title">
                            {{ plan.name }}
                            <nz-tag nzColor="gold" *ngIf="vm.isTrialPlan(plan)">{{
                              'assistant.management.create.pay.trial.tag' | i18n
                            }}</nz-tag>
                            <nz-tag nzColor="green" *ngIf="plan.recommended">{{
                              'assistant.management.create.pay.recommended' | i18n
                            }}</nz-tag>
                          </div>
                          <div class="plan-sub">{{ vm.getPlanSubText(plan) }}</div>
                        </div>
                        <div class="plan-action" *ngIf="vm.selectedPricingItemId === plan.id">{{
                          'assistant.management.create.pay.select' | i18n
                        }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="payment-right">
                  <div class="side-card">
                    <div class="side-title">{{ 'assistant.management.create.pay.preview' | i18n }}</div>
                    <div class="assistant-preview">
                      <div class="preview-avatar">
                        <img
                          *ngIf="vm.avatarPreview; else previewAvatarFallback"
                          [src]="vm.avatarPreview"
                          [alt]="'assistant.management.create.basic.avatar.alt' | i18n"
                        />
                        <ng-template #previewAvatarFallback>
                          <div class="fallback-avatar">{{
                            (vm.createForm.value.name || ('assistant.management.create.pay.preview.fallback' | i18n)).slice(0, 1)
                          }}</div>
                        </ng-template>
                      </div>
                      <div class="preview-meta">
                        <div class="preview-name">{{
                          vm.createForm.value.name || ('assistant.management.create.pay.preview.unnamed' | i18n)
                        }}</div>
                        <div class="preview-desc">{{ vm.createForm.value.description || '-' }}</div>
                      </div>
                    </div>
                    <hr />
                    <div class="preview-section-title">{{ 'assistant.management.create.pay.preview.mode-and-trigger' | i18n }}</div>
                    <div class="preview-metric metric-green">
                      <span class="metric-dot"></span>
                      <span>{{ 'assistant.management.create.pay.preview.mode' | i18n }}{{ vm.getPreviewResponseLabel() | i18n }}</span>
                    </div>
                    <div class="preview-metric metric-blue">
                      <span class="metric-dot"></span>
                      <span
                        >{{ 'assistant.management.create.pay.preview.history' | i18n }}{{ vm.historyDays }}
                        {{ 'assistant.management.create.filter.day-unit' | i18n }}</span
                      >
                    </div>
                    <hr />
                    <div class="preview-note">{{ 'assistant.management.create.pay.preview.note' | i18n }}</div>
                  </div>

                  <div class="side-card settlement-card">
                    <div class="settlement-head">
                      <div class="side-title">{{ 'assistant.management.create.pay.settlement.title' | i18n }}</div>
                      <a class="settlement-link" testId="assistant-management-settlement-priority-link">{{
                        'assistant.management.create.pay.settlement.priority' | i18n
                      }}</a>
                    </div>
                    <div class="bill-block">
                      <div class="bill-label">{{ 'assistant.management.create.pay.settlement.current' | i18n }}</div>
                      <div class="bill-value">{{ vm.getSelectedPlan()?.name }}</div>
                    </div>
                    <div class="bill-block">
                      <div class="bill-label">{{ 'assistant.management.create.pay.settlement.fee' | i18n }}</div>
                      <div class="bill-value">{{ vm.getSelectedPlanPriceText() }}</div>
                    </div>

                    <div class="point-block">
                      <div class="point-head">
                        <span>{{ 'assistant.management.create.pay.balance.uupon' | i18n }}</span>
                        <span>{{ vm.getBalancePoints('uupon') }} {{ 'assistant.management.create.pay.balance.available' | i18n }}</span>
                      </div>
                      <div class="point-use-row">
                        <span>{{ 'assistant.management.create.pay.balance.use' | i18n }}</span>
                        <input
                          class="point-input"
                          type="text"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          [disabled]="vm.isDeductInputDisabled('uupon')"
                          [ngModel]="vm.deductionInputs.uupon"
                          (beforeinput)="vm.blockNonIntegerInput($event)"
                          (input)="vm.onDeductInput('uupon', $event)"
                          placeholder="0"
                          testId="assistant-management-uupon-deduct-input"
                        />
                        <span>{{ 'assistant.management.create.pay.points-unit' | i18n }}</span>
                        <a
                          [class.point-all-disabled]="vm.isDeductInputDisabled('uupon')"
                          (click)="vm.deductAll('uupon')"
                          testId="assistant-management-uupon-deduct-all-link"
                          >{{ 'assistant.management.create.pay.balance.all' | i18n }}</a
                        >
                      </div>
                    </div>

                    <div class="settlement-detail">
                      <div class="settlement-detail-title">{{ 'assistant.management.create.pay.summary.title' | i18n }}</div>
                      <div class="settlement-detail-row" *ngFor="let row of vm.getSettlementDetailRows()">
                        <span>{{ row.label }}</span>
                        <strong>{{ row.value }}</strong>
                      </div>
                    </div>

                    <div class="cash-block">
                      <div class="cash-label">{{ 'assistant.management.create.pay.cash' | i18n }}</div>
                      <div class="cash-value">{{ vm.getSelectedPlanCashText() }}</div>
                      <div class="cash-tip">{{ 'assistant.management.create.pay.cash.tip' | i18n }}</div>
                    </div>
                  </div>

                  <div class="settlement-note">
                    <i nz-icon nzType="bulb"></i>
                    <span>{{ 'assistant.management.create.pay.note' | i18n }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="wizard-footer" testId="assistant-create-wizard-footer">
          <button
            nz-button
            class="footer-btn"
            (click)="vm.createStep === 0 ? vm.closeCreateWizard() : vm.previousCreateStep()"
            testId="assistant-create-cancel-prev-button"
          >
            {{ (vm.createStep === 0 ? 'assistant.management.create.footer.cancel' : 'assistant.management.create.footer.prev') | i18n }}
          </button>
          <div class="footer-right">
            <span class="step-counter">{{ vm.getCurrentStepText() }}</span>
            <button
              nz-button
              nzType="primary"
              class="footer-btn next"
              *ngIf="vm.createStep < vm.lastCreateStepIndex"
              [disabled]="!vm.isCurrentStepValid()"
              (click)="vm.nextCreateStep()"
              testId="assistant-create-next-button"
            >
              {{ 'assistant.management.create.footer.next' | i18n }}
            </button>
            <button
              nz-button
              nzType="primary"
              class="footer-btn pay-btn"
              *ngIf="vm.createStep === vm.lastCreateStepIndex"
              [nzLoading]="vm.submitLoading()"
              [disabled]="vm.submitLoading()"
              [style.background]="'#6b5a45'"
              [style.border-color]="'#6b5a45'"
              [style.color]="'#fff'"
              (click)="vm.submitCreateAssistant()"
              testId="assistant-create-submit-button"
            >
              {{ vm.getSubmitButtonLabelKey() | i18n }}
            </button>
          </div>
        </div>
      </div>
    </nz-spin>
  </ng-container>
</nz-modal>
